module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.person.avatarUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', [_c('span', {
    staticClass: "title is-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.person.name) + "\n        ")])]), _vm._v(" "), (!_vm.person.isMe) ? _c('p', [(_vm.person.isFollowed) ? _c('button', {
    staticClass: "button is-medium is-fullwidth is-outlined",
    on: {
      "click": function($event) {
        _vm.unfollowPerson(_vm.person)
      }
    }
  }, [_vm._v("following")]) : _c('button', {
    staticClass: "button is-primary is-medium is-fullwidth",
    on: {
      "click": function($event) {
        _vm.followPerson(_vm.person)
      }
    }
  }, [_vm._v("follow")])]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v(_vm._s(_vm.person.bio))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-79a637fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Header--narrow.vue
// module id = 290
// module chunks = 1